var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojiSorry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 46C92 71.4048 71.4048 92 46 92C20.5978 92 0 71.4048 0 46C0 20.5978 20.5978 0 46 0C71.4048 0 92 20.5978 92 46Z",
    fill: "#F9BA25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3889 51.1115C32.9174 51.1115 35.7778 47.107 35.7778 42.1671C35.7778 37.2272 32.9174 33.2227 29.3889 33.2227C25.8604 33.2227 23 37.2272 23 42.1671C23 47.107 25.8604 51.1115 29.3889 51.1115Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6111 51.1115C66.1395 51.1115 68.9999 47.107 68.9999 42.1671C68.9999 37.2272 66.1395 33.2227 62.6111 33.2227C59.0826 33.2227 56.2222 37.2272 56.2222 42.1671C56.2222 47.107 59.0826 51.1115 62.6111 51.1115Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8889 66.4441H28.1111C26.7004 66.4441 25.5555 65.3018 25.5555 63.8886C25.5555 62.4753 26.7004 61.333 28.1111 61.333H63.8889C65.3021 61.333 66.4444 62.4753 66.4444 63.8886C66.4444 65.3018 65.3021 66.4441 63.8889 66.4441Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSorry);
export default __webpack_public_path__ + "static/media/EmojiSorry.8db914a2a67523f4275ccc9a5b04b0b2.svg";
export { ForwardRef as ReactComponent };